<template>
	<div class="axis-robotic-arm-list">
		<div class="axis-robotic-arm-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">6-axis Robotic Arm</span>
			</div>

			<div class="list">
				<img :src="solution_image_01" alt="Xhorse"/>

				<ul>
					<li>
						<div class="dot">·</div>
						<div class="ll">Lightweight design, easy to quickly deploy and put into production line;</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">Integrated joint design for easy disassembly and assembly;
						</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">High-performance sealing design, adapt to various harsh environments;</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">Multi-function fixture;</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">Configure vision system and collision detection to realize safe production;
						</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">Drag-and-drop programming, easy to use.</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_precision_04.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01
            };
        }
    }


</script>

<style scoped="">

	.ll {
		width: calc(100% - .625rem);
		margin-bottom: 1.375rem;
	}

	.dot {
		width: .625rem;
	}

	.dot, .ll {
		float: left;
		border: none;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.list > ul > li {
		width: 100%;
	}

	.list > ul {
		width: 100%;
		height: 21rem;
		border: none;
	}

	.list > img {
		width: 100%;
		margin-bottom: 2.75rem;
	}

	.list {
		width: 54.5rem;
		border: none;
		margin-left: 7rem;
	}

	.axis-robotic-arm-con {
		width: 61.5rem;
		height: 45.5625rem;
		border: none;
		margin-left: 0;
	}

	.axis-robotic-arm-list {
		width: 100%;
		height: 45.5625rem;
		border: none;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}

	.warnning {

		width: 100%;
		height: 100px;
		margin: 0 auto;
		text-align: center;
		font-style: oblique;
		font-size: 64px;
		font-family: "Open Sans";
		margin-top: 44px;
		margin-bottom: 44px;

	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-axis-robotic-arm.vue